export default __webpack_public_path__ + "static/media/ownr_even.ca06e80a.svg";